import { ref, computed } from "vue";
import { defineStore, storeToRefs } from "pinia";
import useMyFetch from "@stores/useMyFetch";
import handleError from "@utils/composables/handleError";
import { useMCreativeStore } from "@stores/mCreative";

export const useMTemplatesStore = defineStore("mTemplates", () => {
  const mCreativeStore = useMCreativeStore();
  const { mCreative } = storeToRefs(mCreativeStore);

  const mTemplates = ref([]);

  const selectedTemplateIds = () => mCreative.value?.template_ids ?? [];

  const activeMTemplates = computed(() => {
    return mTemplates.value.filter((el) => selectedTemplateIds().includes(el.id));
  });

  const fetchMTemplates = async () => {
    try {
      const { response, data } = await useMyFetch(`/m_templates`).json();

      if (response.value.ok) {
        mTemplates.value = data.value;
      }
      return response.value.ok;
    } catch (err) {
      handleError(err);
      return false;
    }
  };

  const toggleMTemplate = (id) => {
    const index = mCreative.value.template_ids.findIndex((el) => el === id);
    if (index !== -1) {
      mCreative.value.template_ids.splice(index, 1);
    } else {
      mCreative.value.template_ids.push(id);
    }
  };

  const isMTemplateSelected = (id) => {
    return selectedTemplateIds().includes(id);
  };

  const setTemplateIds = (ids) => {
    mCreative.value.template_ids = [...ids];
  };

  const availableAttributes = computed(() => {
    const selectedTemplates = mTemplates.value.filter((el) => selectedTemplateIds().includes(el.id));
    const attributes = {};
    selectedTemplates.forEach((template) => {
      Object.entries(template.m_template_attributes || {}).forEach(([key, value]) => {
        attributes[key] = value;
      });
    });
    return attributes;
  });

  const currentAttributes = computed(() => mCreative.value.m_template_attributes);

  const setBlankTemplate = () => {
    mCreative.value.template_ids = [mTemplates.value.find((el) => el.name === "blank").id];
    mCreative.value.m_template_attributes = {};
  };

  return {
    mTemplates,
    fetchMTemplates,
    toggleMTemplate,
    isMTemplateSelected,
    setTemplateIds,
    activeMTemplates,
    availableAttributes,
    currentAttributes,
    setBlankTemplate,
  };
});
